var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowmobi4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 131,
    viewBox: "0 0 116 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 110.058V20.377H62.7733C63.6077 20.377 64.2823 19.6853 64.2823 18.8516V4.60833C64.2823 0.13847 70.0341 -1.70623 72.6437 1.92997L112.907 58.2467V58.229C115.818 62.2909 115.818 67.7363 112.907 71.7982L72.6437 128.115C70.0341 131.751 64.2823 129.906 64.2823 125.437V111.566C64.2823 110.732 63.6077 110.058 62.7733 110.058H0Z",
    fill: "url(#paint0_linear_126_300)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1263 82.9092C27.4703 82.9092 25.0703 82.2372 22.9263 80.8932C20.8143 79.5492 19.1503 77.5972 17.9343 75.0372C16.7183 72.4452 16.1103 69.3092 16.1103 65.6292C16.1103 61.9492 16.7183 58.8292 17.9343 56.2692C19.1503 53.6772 20.8143 51.7092 22.9263 50.3652C25.0703 49.0212 27.4703 48.3492 30.1263 48.3492C32.8143 48.3492 35.2143 49.0212 37.3263 50.3652C39.4383 51.7092 41.1023 53.6772 42.3183 56.2692C43.5663 58.8292 44.1903 61.9492 44.1903 65.6292C44.1903 69.3092 43.5663 72.4452 42.3183 75.0372C41.1023 77.5972 39.4383 79.5492 37.3263 80.8932C35.2143 82.2372 32.8143 82.9092 30.1263 82.9092ZM30.1263 77.4852C31.6943 77.4852 33.0543 77.0692 34.2063 76.2372C35.3583 75.3732 36.2543 74.0612 36.8943 72.3012C37.5663 70.5412 37.9023 68.3172 37.9023 65.6292C37.9023 62.9092 37.5663 60.6852 36.8943 58.9572C36.2543 57.1972 35.3583 55.9012 34.2063 55.0692C33.0543 54.2052 31.6943 53.7732 30.1263 53.7732C28.6223 53.7732 27.2783 54.2052 26.0943 55.0692C24.9423 55.9012 24.0303 57.1972 23.3583 58.9572C22.7183 60.6852 22.3983 62.9092 22.3983 65.6292C22.3983 68.3172 22.7183 70.5412 23.3583 72.3012C24.0303 74.0612 24.9423 75.3732 26.0943 76.2372C27.2783 77.0692 28.6223 77.4852 30.1263 77.4852ZM47.9272 74.7972V70.4772L64.4872 48.8292H71.1592L54.8392 70.4772L51.7192 69.5172H78.3592V74.7972H47.9272ZM66.3592 82.4292V74.7972L66.5512 69.5172V62.7492H72.4072V82.4292H66.3592Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_300",
    x1: 21.4542,
    y1: 0,
    x2: 21.4542,
    y2: 130.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowmobi4);
export default __webpack_public_path__ + "static/media/arrowmobi4.128fe33dd27d5b93d829d4919627d0ea.svg";
export { ForwardRef as ReactComponent };